import React from "react";
import { BaseTabedPage } from "../../../../_metronic/layout/components/common/baseTabedPage";
import AuditFormResultPage from "./AuditFormResultPage";
import BuildingAuditFormResultPage from "./BuildingAuditFormResultPage";
import FloorAuditFormResultPage from "./FloorAuditFormResultPage";
import PlaceAuditFormResultPage from "./PlaceAuditFormResultPage";
import RoomAuditFormResultPage from "./RoomAuditFormResultPage";
import SeatAuditFormResultPage from "./SeatAuditFormResultPage";



const components = [
    { id: 1, title: "پردیس / مرکز", url: "/placeFormList", tab: 'place', component: PlaceAuditFormResultPage },
    { id: 2, title: "بلوک", url: "/buildings", tab: 'building', component: BuildingAuditFormResultPage },
    { id: 3, title: "طبقه", url: "/floors", tab: 'floor', component: FloorAuditFormResultPage },
    { id: 4, title: "اتاق", url: "/rooms", tab: 'room', component: RoomAuditFormResultPage },
    { id: 5, title: "تخت", url: "/seats", tab: 'seat', component: SeatAuditFormResultPage },
];


export const AuditResultBasePage = () => {

    return (

        <BaseTabedPage components={components} basePath="/resultForms" />

    );
}
